import React from 'react';
import PropTypes from 'prop-types';

export default class InvoiceHistoryRow extends React.Component {
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="invoice-history-row grid border--top">
				<h3 className="invoice-history-row__description font--body">{this.props.description}</h3>
				<span className="invoice-history-row__date font--meta">{this.props.date}</span>
			</div>
		);
	}
}

InvoiceHistoryRow.propTypes = {
	description: PropTypes.string.isRequired,
	date: PropTypes.string.isRequired
};
